// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__3W33C","date":"CreditCardExpiryDate_date__2zKRF"};